import { mapAuditDates } from '@mkp/shared/data-access';
import { VacancyDto, VacancyModel } from './vacancy.models';

export const toViewModel = (vacancyDto: VacancyDto): VacancyModel => ({
  ...vacancyDto,
  ...mapAuditDates(vacancyDto),
  videoUrl: vacancyDto.videos?.[0]?.url,
});
